/*
   Credit bar, shown only on home page and journey selection
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSelectedArtwork } from '../../actions/artwork-actions'
import { setJourneyProgressStep, resetToJourney } from '../../actions/journey-actions'

// set journey
// set nav
// set artwork
const clickHandler = (props) => {
   const { resetToJourney, setSelectedArtwork, setJourneyProgressStep } = props
   const galleryId = 'bottom'
   resetToJourney(galleryId, 1)
   setSelectedArtwork(galleryId, 15, 0)
   setSelectedArtwork(galleryId, 20, 1)
   setSelectedArtwork(galleryId, 27, 2)
   setSelectedArtwork(galleryId, 32, 3)
   setSelectedArtwork(galleryId, 38, 4)
   setJourneyProgressStep(galleryId, 4)
}

const DebugButton = props => (
  <button className={'medium-1 debug-button'} onClick={() => clickHandler(props)}>DEBUG</button>
)

const mapStateToProps = (state, ownProps) => ({...ownProps})
const mapDispatchToProps = dispatch => bindActionCreators({
   setSelectedArtwork,
   setJourneyProgressStep,
   resetToJourney
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DebugButton) 


// WEBPACK FOOTER //
// ./src/components/JourneyHome/DebugButton.js